export class Company {
    Id: number = 0;
    CompanyGuid: string = '';
    WebSite: string = '';
    CustomerId: number = 0;
    Email: string = '';
    CompanyName: string = '';
    License_ID: number = 0;
    LicenseStartDate: string = '';
    LicenseEndDate: string = '';
    LicenseType: string = '';
    LicenseName: string = '';
    LicenseStatus: string = '';
    LicenseRef: string = '';
    LicenseOwnerId: number = 0;
    MaxPlans: number = 0;
    PriceOptionCodes: string[] = [];    
    Country_ID: number = 0;
    Industry_ID: number = 0;
    IsSelected: boolean = false;
    IsOwnTeam: boolean = false;
    IsTeamOwner: boolean = false;
    HasEverHadTrial: boolean = false;
    LastSortType: number = 0;

    // upgrade/trial logic area
    CanUpgrade: boolean = true;
    upgradeBtnText: string = '';
    upgradeBtnWidth: number = 0;
    CanStartTrial: boolean = false;
    CanCreateNewPlan: boolean = false;
    ActivePlansCount: number = 0;

    constructor(company?: Company) {
        if (company !== undefined) {
            this.Id = company.Id;
            this.CompanyGuid = company.CompanyGuid;
            this.WebSite = company.WebSite;
            this.CustomerId = company.CustomerId;
            this.Email = company.Email;
            this.CompanyName = company.CompanyName;
            this.License_ID = company.License_ID;
            this.Country_ID = company.Country_ID;
            this.Industry_ID = company.Industry_ID;
            this.IsSelected = company.IsSelected;
            this.HasEverHadTrial = company.HasEverHadTrial;
        }
    }

    public IsEqual(company: Company): boolean {
        return this.Id === company.Id &&
            this.CompanyGuid === company.CompanyGuid &&
            this.WebSite === company.WebSite &&
            this.CustomerId === company.CustomerId &&
            this.Email === company.Email &&
            this.CompanyName === company.CompanyName &&
            this.License_ID === company.License_ID &&
            this.Country_ID === company.Country_ID &&
            this.Industry_ID === company.Industry_ID &&
            this.IsSelected === company.IsSelected &&
            this.HasEverHadTrial === company.HasEverHadTrial;

    }
}